"use client"

import styled from "@emotion/styled"
import { Box, Button } from "@mui/material"
import { useTranslations } from "next-intl"
import { Dispatch, SetStateAction } from "react"
import NewText from "./NewText/NewText"
import { FormFailIcon, FormSuccessIconCareer } from "./icons"
import { sharedColors as colors } from "./theme/colors"

const StyledForm = styled.div`
  padding: 24px 16px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  min-height: 275px;
  text-align: center;
  background: #ffffff;
  box-shadow: 0px 4px 12px 0px #00000029;
  border-radius: 16px 16px 0 0;
  width: 100%;
  ${(props) => props.theme.breakpoints.up("md")} {
    border-radius: 16px;
    max-width: 360px;
  }
`
const StyledText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

const StyledButton = styled(Button)<{ $success: boolean }>`
  display: flex;
  min-width: 162px;
  height: 48px;
  padding: 8px 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 200px;
  border: 2px solid ${(p) => (p.$success ? p.theme.colors.buttonActiveBackgroundColor : "black")};
  background: ${(p) => (p.$success ? p.theme.colors.buttonActiveBackgroundColor : "white")};
  color: ${(p) => (p.$success ? "white" : "black")};
  text-decoration: none;
  font-size: 18px;
  font-weight: 600;
  :hover {
    text-decoration: none;
    border: 2px solid ${(p) => (p.$success ? p.theme.colors.buttonActiveBackgroundColor : "black")};
    background: ${(p) => (p.$success ? p.theme.colors.buttonActiveBackgroundColor : "white")};
    color: ${(p) => (p.$success ? "white" : "black")};
  }
`

const StyledIconWrapper = styled.div<{ $success: boolean }>`
  width: 60px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background-color: ${(p) => (p.$success ? "#E3F8E6" : "#FFE6E4")};
`

type Props = {
  state: "success" | "fail"
  setIsSubmitted: Dispatch<SetStateAction<boolean>>
  isReferral?: boolean
  handleSuccess?: () => void
}
function SuccessFailJob({ state, setIsSubmitted, isReferral, handleSuccess }: Props) {
  const t = useTranslations("SuccessFailBox")

  const handleClick = () => {
    if (state === "success" && handleSuccess) {
      handleSuccess()
    }
    setIsSubmitted(false)
  }

  return (
    <StyledForm>
      <Box
        display={"flex"}
        flexDirection={"column"}
        gap={state === "success" ? "16px" : "8px"}
        alignItems={"center"}
      >
        <StyledIconWrapper $success={state === "success"}>
          {state === "success" ? (
            <FormSuccessIconCareer width={"40px"} height={"40px"} />
          ) : (
            <FormFailIcon width={"34px"} height={"34px"} />
          )}
        </StyledIconWrapper>
        <StyledText>
          <NewText
            component={"h3"}
            desktopFontSize={24}
            desktopFontWeight={700}
            desktopLineHeight={"35px"}
            color={colors.black}
          >
            {state === "success"
              ? isReferral
                ? "איזה כיף!"
                : "הגשת מועמדותך נקלטה בהצלחה!"
              : "פנייתך לא נשלחה"}
          </NewText>
          {isReferral && (
            <NewText
              component={"p"}
              desktopFontSize={18}
              color={colors.black}
              desktopLineHeight={"26px"}
              dangerouslySetInnerHTML={{
                __html: state === "success" ? t("successCareerReferral") : t("errorCareer"),
              }}
            />
          )}
        </StyledText>
      </Box>
      <StyledButton $success={state === "success"} onClick={handleClick}>
        {state === "fail" ? t("tryAgain") : "חזרה לכל המשרות"}
      </StyledButton>
    </StyledForm>
  )
}

export default SuccessFailJob
